import { call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as http from 'utils/http';
import config from 'config';

import { setQuote, setQuoteLoading, setQuoteReady } from './duck';

import { displayError } from 'redux/modules/error-handler/effects';
import { JOURNEY_COST } from 'redux/modules/error-handler/constants';

function* costQuote({
  id,
  stops = [],
  extra_costs = [],
  distance_at_creation,
  distance_type,
  created_at,
  pricing_version,
  extra_version,
}) {
  const url = `${config.API_URL}costing_quote/`;
  const quote = yield call(http.post, url, {
    id,
    stops,
    extra_costs,
    distance_at_creation,
    distance_type,
    created_at,
    pricing_version,
    extra_version,
  });
  return quote;
}

function* handleCostQuote({ payload }) {
  yield call(delay, 2000);
  const { isValid, values, setErrors } = payload;
  if (isValid) {
    yield put(setQuoteLoading(true));
    yield put(setQuoteReady(false));
    const journey = values;
    try {
      const quote = yield call(costQuote, journey);
      yield put(setQuote(quote));
      yield put(setQuoteLoading(false));
      yield put(setQuoteReady(true));
    } catch (err) {
      yield put(displayError(err, JOURNEY_COST));
      yield put(setQuoteLoading(false));
      yield put(setQuoteReady(false));

      const errors = yield call(http.getError, err);
      yield call(setErrors, errors);
    }
  }
}

export { costQuote, handleCostQuote };
